/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GenerationRefundRequestReasonEnum = {
    deliveryLost: 'delivery_lost'
};
/**
 * Check if a given object implements the GenerationRefundRequest interface.
 */
export function instanceOfGenerationRefundRequest(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
export function GenerationRefundRequestFromJSON(json) {
    return GenerationRefundRequestFromJSONTyped(json, false);
}
export function GenerationRefundRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': json['reason'],
    };
}
export function GenerationRefundRequestToJSON(json) {
    return GenerationRefundRequestToJSONTyped(json, false);
}
export function GenerationRefundRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': value['reason'],
    };
}
